var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgChannelFacebook14 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 14,
  height: 14,
  viewBox: "0 0 14 14",
  role: "img"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("rect", {
  width: 14,
  height: 14,
  fill: "#FF3CA0",
  rx: 2
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M6.049 11V7.505H5V5.934h1.049v-.507C6.049 3.861 6.282 3 8.146 3h.728v1.428h-.728c-.63 0-.535.755-.535 1.105v.401H9l-.411 1.57H7.61V11z"
}))));
export default SvgChannelFacebook14;